/* Farog — Complete the Look bundles (<look-bundle>). Used by snippets/look-bundle.liquid */
(function () {
  if (customElements.get('look-bundle')) return;

  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;
    format = format || 'Rs. {{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    var key = match ? match[1] : 'amount';
    function fmt(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var value;
    if (key === 'amount_no_decimals') value = fmt(0, ',', '.');
    else if (key === 'amount_with_comma_separator') value = fmt(2, '.', ',');
    else if (key === 'amount_no_decimals_with_comma_separator') value = fmt(0, '.', ',');
    else if (key === 'amount_with_apostrophe_separator') value = fmt(2, "'", '.');
    else value = fmt(2, ',', '.');
    return format.replace(placeholder, value);
  }

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  class LookBundle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-lb-row]'));
      this.button = this.querySelector('[data-lb-add]');
      this.discount = parseFloat(this.dataset.discount) || 0;
      this.format = this.dataset.moneyFormat;

      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-lb-variant]')) e.target.dataset.touched = 'true';
        if (e.target.matches('[data-lb-check], [data-lb-variant]')) {
          e.stopPropagation();
          self.update();
        }
      });
      if (this.button) this.button.addEventListener('click', function (e) { e.preventDefault(); self.add(); });
      this.update();
    }

    variantFor(row) {
      var input = row.querySelector('[data-lb-variant]');
      if (!input) return null;
      // Keep "This piece" in step with the size chosen in the main product form
      if (row.hasAttribute('data-lb-main') && input.dataset.touched !== 'true') {
        var self = this;
        var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) { return !self.contains(f) && !f.closest('cart-drawer') && !f.closest('[data-fgb]') && !f.closest('look-bundle'); });
        forms.sort(function (a, b) { return (b.closest('[id$="__main"]') ? 1 : 0) - (a.closest('[id$="__main"]') ? 1 : 0); });
        for (var i = 0; i < forms.length; i++) {
          var idInput = forms[i].querySelector('[name="id"]');
          if (idInput && idInput.value) {
            var opt = input.tagName === 'SELECT' ? input.querySelector('option[value="' + idInput.value + '"]') : null;
            if (opt) { input.value = idInput.value; }
            break;
          }
        }
      }
      return input;
    }

    priceFor(input) {
      if (!input) return 0;
      if (input.tagName === 'SELECT') {
        var opt = input.options[input.selectedIndex];
        return parseInt(opt && opt.dataset.price, 10) || 0;
      }
      return parseInt(input.dataset.price, 10) || 0;
    }

    selection() {
      var self = this;
      return this.rows.filter(function (row) {
        var c = row.querySelector('[data-lb-check]');
        return c && c.checked && !c.disabled;
      }).map(function (row) {
        var input = self.variantFor(row);
        return { row: row, id: input && input.value, price: self.priceFor(input) };
      });
    }

    update() {
      var self = this;
      var picked = this.selection();
      this.rows.forEach(function (row) {
        var input = row.querySelector('[data-lb-variant]');
        var priceEl = row.querySelector('[data-lb-price]');
        if (priceEl && input) priceEl.textContent = formatMoney(self.priceFor(input), self.format);
      });
      var total = picked.reduce(function (s, p) { return s + p.price; }, 0);
      var allPicked = picked.length === this.rows.filter(function (r) { var c = r.querySelector('[data-lb-check]'); return c && !c.disabled; }).length;
      var countEl = this.querySelector('[data-lb-count]');
      var totalEl = this.querySelector('[data-lb-total]');
      var compareEl = this.querySelector('[data-lb-compare]');
      var saveEl = this.querySelector('[data-lb-save]');
      if (countEl) countEl.textContent = picked.length;
      // Saving mirrors the Shopify discount (Buy X get Y): X% off one accessory per garment, cheapest first
      var garments = picked.filter(function (p) { return !p.row.hasAttribute('data-lb-accessory'); }).length;
      var accPrices = picked.filter(function (p) { return p.row.hasAttribute('data-lb-accessory'); }).map(function (p) { return p.price; }).sort(function (a, b) { return a - b; });
      var eligible = garments > 0 ? accPrices.slice(0, garments) : [];
      var saving = Math.round(eligible.reduce(function (s, v) { return s + v; }, 0) * this.discount / 100);
      var showSaving = this.discount > 0 && saving > 0;
      var finalTotal = total - saving;
      if (totalEl) totalEl.textContent = formatMoney(finalTotal, this.format);
      if (compareEl) { compareEl.hidden = !showSaving; compareEl.textContent = showSaving ? formatMoney(total, this.format) : ''; }
      if (saveEl) { saveEl.hidden = !showSaving; saveEl.textContent = showSaving ? 'You save ' + formatMoney(saving, this.format) + ' · ' + this.discount + '% off an accessory' : ''; }
      if (this.button) this.button.disabled = picked.length === 0;
    }

    showError(msg) {
      var el = this.querySelector('[data-lb-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    add() {
      var self = this;
      var picked = this.selection().filter(function (p) { return p.id; });
      if (!picked.length || this.button.getAttribute('aria-busy') === 'true') return;
      this.showError('');
      this.button.setAttribute('aria-busy', 'true');
      this.button.classList.add('is-loading');
      this.button.disabled = true;

      var onCartPage = !!document.querySelector('cart-items-component[data-section-id]') && !document.querySelector('cart-drawer');
      var drawer = document.querySelector('cart-drawer');
      var drawerId = drawer && drawer.dataset.sectionId;
      var ids = new Set();
      if (drawerId) ids.add(drawerId);
      document.querySelectorAll('cart-items-component[data-section-id], cart-drawer-items[data-section-id]').forEach(function (el) { ids.add(el.dataset.sectionId); });
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) ids.add('cart-icon-bubble');

      var body = { items: picked.map(function (p) { return { id: Number(p.id), quantity: 1 }; }) };
      if (ids.size) { body.sections = Array.from(ids).join(','); body.sections_url = window.location.pathname; }

      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          var json = res.json || {};
          if (!res.ok || json.status) {
            self.showError(json.description || json.message || 'Could not add the look. Please try again.');
            return;
          }
          var sections = json.sections || {};
          var handled = false;

          if (drawer && drawerId && sections[drawerId] && typeof drawer.renderContents === 'function') {
            try {
              drawer.classList.remove('is-empty');
              var state = { id: picked[0].id, sections: {} };
              Object.keys(sections).forEach(function (k) { state.sections[k] = sections[k]; });
              state.sections['cart-drawer'] = sections[drawerId];
              drawer.renderContents(state);
              handled = true;
            } catch (e) {}
          }

          if (!handled) {
            if (bubble && sections['cart-icon-bubble']) {
              var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var bsrc = bdoc.querySelector('.shopify-section');
              if (bsrc) bubble.innerHTML = bsrc.innerHTML;
            }
            var rest = {};
            Object.keys(sections).forEach(function (k) { if (k !== 'cart-icon-bubble' && sections[k]) rest[k] = sections[k]; });
            var comp = document.querySelector('cart-items-component') || document.querySelector('cart-drawer-items');
            if (comp && typeof comp.updateSections === 'function' && Object.keys(rest).length) {
              try { comp.updateSections(rest); handled = true; } catch (e) {}
            }
          }

          return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
              cart.sections = sections;
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              if (!handled) window.location.href = self.dataset.cartUrl || rootUrl() + 'cart';
              else if (onCartPage) window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        })
        .catch(function () { self.showError('Could not add the look. Please try again.'); })
        .finally(function () {
          self.button.removeAttribute('aria-busy');
          self.button.classList.remove('is-loading');
          self.update();
        });
    }
  }

  customElements.define('look-bundle', LookBundle);
})();

/* Keep "Complete the Look" in step with the size picked on the main product form */
(function () {
  function mainId() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')).filter(function (f) {
      return !f.closest('look-bundle') && !f.closest('cart-drawer') && !f.closest('[data-fgb]');
    });
    forms.sort(function (a, b) { return (b.closest('[id$="__main"]') ? 1 : 0) - (a.closest('[id$="__main"]') ? 1 : 0); });
    for (var i = 0; i < forms.length; i++) {
      var inp = forms[i].querySelector('[name="id"]');
      if (inp && inp.value) return String(inp.value);
    }
    return null;
  }
  var last = null, timer = null;
  function check() {
    var id = mainId();
    if (!id || id === last) return;
    var first = last === null;
    last = id;
    document.querySelectorAll('look-bundle').forEach(function (lb) {
      var sel = lb.querySelector('[data-lb-main] [data-lb-variant]');
      if (!sel) return;
      if (!first) sel.dataset.touched = 'false';
      if (sel.tagName === 'SELECT' && sel.querySelector('option[value="' + id + '"]')) sel.value = id;
      if (typeof lb.update === 'function') lb.update();
    });
  }
  function soon(ms) { clearTimeout(timer); timer = setTimeout(check, ms || 80); }
  function outside(e) { return !(e.target && e.target.closest && e.target.closest('look-bundle')); }
  document.addEventListener('change', function (e) { if (outside(e)) { soon(60); setTimeout(check, 400); } }, true);
  document.addEventListener('click', function (e) { if (outside(e)) { soon(150); setTimeout(check, 600); } }, true);
  ['variant:change', 'variant:changed', 'variant:update', 'variantChange', 'on:variant:change'].forEach(function (n) {
    document.addEventListener(n, function () { soon(30); });
  });
  setInterval(check, 800);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { soon(50); }); else soon(50);
})();
